import { DateTime } from 'luxon'

export const seedPickupFromArrival = (
  arrivalIso: string,
  bufferMinutes = 30,
): Date => {
  const arrival = DateTime.fromISO(arrivalIso, { setZone: true })
  if (!arrival.isValid) return new Date()
  const local = arrival.plus({ minutes: bufferMinutes })
  return new Date(
    local.year,
    local.month - 1,
    local.day,
    local.hour,
    local.minute,
    local.second,
  )
}
